module.exports = __webpack_public_path__ + "static/media/5-ads-display.3f7c37f1.mp4";